if (!customElements.get('dwan-brand-footer')) {
  class DwanBrandFooter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.groups = Array.from(this.querySelectorAll('.dwan-footer__group'));
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.mobileState = new Map(this.groups.map((group) => [group, group.hasAttribute('data-mobile-open')]));
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };

      this.groups.forEach((group) => {
        const summary = group.querySelector('summary');
        summary.addEventListener('click', (event) => {
          if (this.desktop.matches) event.preventDefault();
        }, options);
        group.addEventListener('toggle', () => {
          if (this.desktop.matches) {
            group.open = true;
          } else {
            this.mobileState.set(group, group.open);
          }
        }, options);
      });

      this.updateLayout = () => {
        this.groups.forEach((group) => {
          const summary = group.querySelector('summary');
          group.open = this.desktop.matches || this.mobileState.get(group);
          if (this.desktop.matches) {
            summary.setAttribute('tabindex', '-1');
          } else {
            summary.removeAttribute('tabindex');
          }
        });
      };
      this.desktop.addEventListener('change', this.updateLayout, options);
      this.updateLayout();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.initialized = false;
    }
  }
  customElements.define('dwan-brand-footer', DwanBrandFooter);
}
